import script from "./NotifyOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./NotifyOverlay.vue?vue&type=script&setup=true&lang=js"

import "./NotifyOverlay.vue?vue&type=style&index=0&id=4c6c719b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6c719b"]])

export default __exports__